/**
 * frontend/src/utils/heatDisplay.js
 * SoundDAO Sprint 6-Zero Milestone 4 — public heat visibility rules.
 *
 * SEASON ZERO — revert at 100 weekly-active players (Season One).
 * At 11 users almost every creator sits at Cold or Rising, and publicly
 * stamping "❄️ Cold" on an artist's profile is an anti-endorsement: it tells a
 * visitor not to bother. Below Warm we show nothing at all rather than a
 * discouraging label. Warm and above still display, because at that point the
 * badge is doing the job it was designed for.
 *
 * SEASON ONE revert: set PUBLIC_HEAT_MIN_TIER to null to show every tier again.
 */

// Tiers at or above this index are publicly visible.
const HEAT_TIER_ORDER = ['Cold', 'Rising', 'Warm', 'Hot', 'BREAKING'];

// SEASON ZERO value — was null (show everything).
const PUBLIC_HEAT_MIN_TIER = 'Warm';

/** Should this heat tier be shown on a PUBLIC surface? */
export function isHeatPublic(tier) {
  if (!PUBLIC_HEAT_MIN_TIER) return Boolean(tier);
  const i   = HEAT_TIER_ORDER.indexOf(tier);
  const min = HEAT_TIER_ORDER.indexOf(PUBLIC_HEAT_MIN_TIER);
  return i >= 0 && min >= 0 && i >= min;
}

/**
 * Should a creator's STAGE be shown publicly? Raw is the floor and carries no
 * signal, so roster rows stop rendering "RAW · COLD" entirely (5C decision:
 * the stage badge is hidden at Raw).
 */
export function isStagePublic(stage) {
  return Boolean(stage) && stage !== 'Raw';
}

/**
 * The combined "Stage · Heat" label for a roster/discovery row, with each half
 * dropped when it is not public. Returns null when there is nothing to show.
 */
export function publicStageHeatLabel(stage, tier) {
  const parts = [];
  if (isStagePublic(stage)) parts.push(stage);
  if (isHeatPublic(tier))   parts.push(tier);
  return parts.length ? parts.join(' \u00b7 ') : null;
}

export { HEAT_TIER_ORDER, PUBLIC_HEAT_MIN_TIER };
